// utils
// export const formatTimeSlots = (event) => {
//     const startDate = event.start_time ? new Date(event.start_time) : null;
//     const endDate = event.end_time ? new Date(event.end_time) : null;
//     const eventName = event.event_name === "" ? "NA" : event.event_name;

//     // Function to format the date components
//     function formatDateComponents(date) {
//         if (!date) return null;
//         return {
//             date: date.getDate(),
//             month: date.getMonth() + 1, // JavaScript months are 0-indexed
//             year: date.getFullYear(),
//             time: date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })
//         };
//     }

//     // Format the date components (date, month, year, time)
//     const startFormatted = startDate ? formatDateComponents(startDate) : null;
//     const endFormatted = endDate ? formatDateComponents(endDate) : null;

//     // Case when both start and end times are missing
//     if (!startDate && !endDate) {
//         return {
//             startDate: null,
//             endDate: null,
//             id: eventName,
//         };
//     }

//     // Case when only start time is present
//     if (startDate && !endDate) {
//         return {
//             startDate: startFormatted,
//             endDate: null,
//             id: eventName,
//         };
//     }

//     // Case when only end time is present
//     if (!startDate && endDate) {
//         return {
//             startDate: null,
//             endDate: endFormatted,
//             id: eventName,
//         };
//     }

//     // Case when both start and end times are present
//     if (startDate && endDate) {
//         if (startDate.toDateString() === endDate.toDateString()) {
//             // If the start and end date are the same, return both as one time range
//             return {
//                 startDate: startFormatted,
//                 endDate: {
//                     date: endFormatted.date,
//                     month: endFormatted.month,
//                     year: endFormatted.year,
//                     time: endFormatted.time
//                 },
//                 id: eventName,
//             };
//         } else {
//             // If the start and end date are different, return both separately
//             return {
//                 startDate: startFormatted,
//                 endDate: endFormatted,
//                 id: eventName,
//             };
//         }
//     }
// };

export const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
    return `${day} ${month} ${time}`;
};

export const formatEndDate = (start, end) => {
    if (!start && !end) return '';
    const startDate = new Date(start);
    const endDate = new Date(end);
    const day = endDate.getDate();
    const month = endDate.toLocaleString('default', { month: 'short' });
    const time = endDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });

    if (startDate.getFullYear() === endDate.getFullYear() &&
        startDate.getMonth() === endDate.getMonth() &&
        startDate.getDate() === endDate.getDate()) {
        console.log('Both dates fall on the same calendar day.');
        return `${time}`
    }
    return `${day} ${month} ${time}`;
};

export const dropdownFormatter = (event) => {
    const { event_name, start_time, end_time } = event;

    if (event_name === "") {
        if (!start_time && !end_time) {
            return "NA";
        } else if (!start_time) {
            return `NA (NA - ${formatDate(end_time)})`;
        } else if (!end_time) {
            return `NA (${formatDate(start_time)})`;
        } else {
            return `NA (${formatDate(start_time)} - ${formatDate(end_time)})`;
        }
    } else {
        if (!start_time && !end_time) {
            return event_name;
        } else if (!start_time) {
            return `${event_name} (NA - ${formatDate(end_time)})`;
        } else if (!end_time) {
            return `${event_name} (${formatDate(start_time)})`;
        } else {
            return `${event_name} (${formatDate(start_time)} - ${formatDate(end_time)})`;
        }
    }
};

// export const getMonthShortname = (month) => {
//     const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
//     return months[month - 1];
// };

// // Function to format the event data based on startDate and endDate
// export const formatEventData = (event) => {
//     const startDate = event.startDate;
//     const endDate = event.endDate;

//     // Case when both startDate and endDate are null
//     if (startDate === null && endDate === null) {
//         return `${event.id}`;
//     }

//     // Case when startDate is null, but endDate is present
//     if (startDate === null && endDate !== null) {
//         return `${event.id} (NA - ${endDate.date} ${getMonthShortname(endDate.month)}, ${endDate.time})`;
//     }

//     // Case when endDate is null, but startDate is present
//     if (endDate === null && startDate !== null) {
//         return `${event.id} (${startDate.date} ${getMonthShortname(startDate.month)}, ${startDate.time})`;
//     }

//     // Case when both startDate and endDate are present
//     if (startDate && endDate) {
//         if (startDate.date === endDate.date && startDate.month === endDate.month && startDate.year === endDate.year) {
//             return `${event.id} (${startDate.date} ${getMonthShortname(startDate.month)}, ${startDate.time} - ${endDate.time})`;
//         }
//         return `${event.id} (${startDate.date} ${getMonthShortname(startDate.month)}, ${startDate.time} - ${endDate.date} ${getMonthShortname(endDate.month)}, ${endDate.time})`;
//     }
// };

// export const sortEventsByStartDate = (events) => {
//     return events.sort((a, b) => {
//         const getStartDateAsDate = (event) => {
//             if (!event.startDate || event.startDate === "") return Infinity;
//             return new Date(event.startDate.year, event.startDate.month - 1, event.startDate.date,
//                 ...event.startDate.time.split(":").map(num => parseInt(num)));
//         };

//         const dateA = getStartDateAsDate(a);
//         const dateB = getStartDateAsDate(b);

//         return dateA - dateB;
//     });
// };

export const convertDateTime = (inputStr) => {
    if (inputStr === "" && inputStr === undefined) {
        return "";
    }

    const inputDate = new Date(inputStr + ` ${new Date().getFullYear()}`);

    const year = inputDate.getFullYear();
    const month = String(inputDate.getMonth() + 1).padStart(2, '0');
    const day = String(inputDate.getDate()).padStart(2, '0');
    const hours = String(inputDate.getHours()).padStart(2, '0');
    const minutes = String(inputDate.getMinutes()).padStart(2, '0');
    const seconds = "00";

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

// export const revertTime = (formattedTime) => {
//     const revertTimeFormat = {
//         start_time: "",
//         end_time: "",
//     };

//     const datePattern = /(\d{1,2} [a-zA-Z]+ \d{4})/; // Matches "Oct 17, 2025"
//     const timePattern = /(\d{2}):(\d{2}) (AM|PM)/;    // Matches "12:00 PM"

//     // Split the formatted time into start and end parts
//     const [startPart, endPart] = formattedTime.split(' - ');

//     let startDate, endDate;

//     // Helper function to format date as "YYYY-MM-DD HH:mm:ss"
//     const formatDate = (date) => {
//         const year = date.getFullYear();
//         const month = String(date.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
//         const day = String(date.getDate()).padStart(2, '0');
//         const hours = String(date.getHours()).padStart(2, '0');
//         const minutes = String(date.getMinutes()).padStart(2, '0');
//         const seconds = String(date.getSeconds()).padStart(2, '0');
//         return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//     };

//     // If both start and end parts are "NA", return the default revert format
//     if (startPart === "NA" && endPart === "NA") return revertTimeFormat;

//     // Process the start part (Always has date and time)
//     if (startPart !== "NA" && startPart) {
//         const startDateMatch = startPart.match(datePattern);
//         const startTimeMatch = startPart.match(timePattern);

//         if (startDateMatch && startTimeMatch) {
//             startDate = new Date(`${startDateMatch[0]} ${startTimeMatch[1]}:${startTimeMatch[2]} ${startTimeMatch[3]}`);
//             revertTimeFormat.start_time = formatDate(startDate);
//         } else {
//             console.error('Invalid start part format:', startPart);
//         }
//     }

//     // Process the end part (Could have either a full date and time or just a time)
//     if (endPart !== "NA" && endPart) {
//         const endDateMatch = endPart.match(datePattern);
//         const endTimeMatch = endPart.match(timePattern);

//         if (endDateMatch && endTimeMatch) {
//             // Full date and time (both date and time present in endPart)
//             endDate = new Date(`${endDateMatch[0]} ${endTimeMatch[1]}:${endTimeMatch[2]} ${endTimeMatch[3]}`);
//             revertTimeFormat.end_time = formatDate(endDate);
//         } else if (endTimeMatch) {
//             // If only time is provided in endPart, assume the same date as the start date
//             if (startDate) {
//                 const sameDateEnd = new Date(`${startDate.toLocaleDateString()} ${endTimeMatch[1]}:${endTimeMatch[2]} ${endTimeMatch[3]}`);
//                 revertTimeFormat.end_time = formatDate(sameDateEnd);
//             } else {
//                 console.error('No start date available to assume for end part time:', endPart);
//             }
//         } else {
//             console.error('Invalid end part format:', endPart);
//         }
//     }

//     return revertTimeFormat;
// };

export const timeFormatter = (event) => {
    const { start_time, end_time } = event;

    if (!start_time && !end_time) {
        return "NA";
    } else if (!start_time) {
        return `NA - ${formatDate(end_time)}`;
    } else if (!end_time) {
        return `${formatDate(start_time)}`;
    } else {

        return `${formatDate(start_time)} - ${formatEndDate(start_time, end_time)}`;
    }
};

export const isUndefined = (mixed_var) => {
    if (typeof mixed_var === "undefined" || mixed_var === undefined || mixed_var === null) {
        return true;
    }
    mixed_var += '';
    if (mixed_var === 'undef' || mixed_var === 'undefined') return true;
    return false;
};

export const empty = (mixed_var) => {
    // Checks if the argument variable is empty
    // undefined, null, false, number 0, empty string,
    // string "0", objects without properties and empty arrays
    // are considered empty
    var undef, key, i, len;
    var emptyValues = [undef, undefined, null, false, 0, "", "0"];

    for (i = 0, len = emptyValues.length; i < len; i++) {
        if (mixed_var === emptyValues[i]) {
            return true;
        }
    }

    if (typeof mixed_var === "object") {
        for (key in mixed_var) {
            // TODO: should we check for own properties only?
            //if (mixed_var.hasOwnProperty(key)) {
            return false; //non-empty object or array
            //}
        }
        return true;
    }

    return false;
};

export const isEmpty = (str) => {
    if (isUndefined(str)) return true;

    if (!empty(str)) {
        str += '';
        if (str === 'undefined') return true;
        str.replace(/^\s+|\s+$/g, '');
        return (str === '' || str === 0);
    }
    return true;
};

export const extractDataFromArray = (dataArr, paramsArr, defaultRetVal = '') => {
    var data = defaultRetVal;
    try {
        if (!isEmpty(dataArr) && !isUndefined(paramsArr)) {
            data = dataArr;
            paramsArr = typeof paramsArr === "string" ? paramsArr.split(".") : paramsArr
            var len = paramsArr.length;
            for (var i = 0; i < len; ++i) {
                if (!isUndefined(paramsArr[i])) {
                    data = data[paramsArr[i]];
                }
            }
        }
        if (isUndefined(data)) {
            data = defaultRetVal;
        }
    }
    catch (e) {
        data = defaultRetVal;
    }

    return data;
};


export const logoutCookies = () => {
    eraseCookie("userwork");
    eraseCookie("login");
    eraseCookie("email");
    eraseCookie("uid");
    eraseCookie("sid");
    eraseCookie("bulk_folders-grid-layout");
    eraseCookie("qr_folders-grid-layout");

    logoutAllCookies();

    // removal of authtk
    localStorage.removeItem("Authtk");
};

export const logoutAllCookies = () => {
    var pairs = document.cookie.split(";");
    for (var i = 0; i < pairs.length; ++i) {
        var pair = pairs[i].split("=");
        var c = (pair[0] + '').trim();

        let prefix = "qr-";
        if (isDev()) {
            prefix += 'DEV-';
        } else if (isLocal()) {
            prefix += 'LOCAL-';
        } else if (isStag()) {
            prefix += 'STAG-';
        }

        if (c.startsWith(prefix)) {
            c = c.replace(prefix, '');
            if (c !== '' && c !== 'B' && c !== 'b' && c !== 'qrcc_ck_pref') {
                eraseCookie(c);
            }
        }
    }
};

export const eraseCookie = (name) => {

    createCookie(name, '', 0);

    let prefix = "qr-";
    if (isDev()) {
        prefix += 'DEV-';
    } else if (isLocal()) {
        prefix += 'LOCAL-';
    } else if (isStag()) {
        prefix += 'STAG-';
    }

    document.cookie = prefix + name + '=;max-age=0;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.qrcodechimp.com';
    document.cookie = prefix + name + '=;max-age=0;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.www.qrcodechimp.com';
    document.cookie = prefix + name + '=;max-age=0;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.' + window.location.host;
    document.cookie = prefix + name + '=;max-age=0;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

export const createCookie = (name, value, days) => {
    let expires;
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    }
    else expires = "";
    let prefix = "qr-";
    if (isDev()) {
        prefix += 'DEV-';
    } else if (isLocal()) {
        prefix += 'LOCAL-';
    } else if (isStag()) {
        prefix += 'STAG-';
    }
    // console.log(prefix);
    document.cookie = prefix + name + "=" + value + expires + "; path=/; domain=." + window.location.host;
};

export const isDev = () => {
    const subdomain = window.location.host.split('.')[0];
    return subdomain === 'dev' || subdomain === 'qd' || subdomain === 'dev-dashboard';
};

export const isStag = () => {
    const subdomain = window.location.host.split('.')[0];
    return subdomain === 'sm' || subdomain === 's' || subdomain === 's-dashboard';
};

export const isLocal = () => {
    const subdomain = window.location.host.split('.')[0];
    return subdomain === 'l' || subdomain === 'l-dashboard';
};

export const signInCallback = (requestData, response) => {
    // console.log("signInCallBack", requestData, response);
    // console.log(extractDataFromArray("here", response, ["data", "authToken"], {}));
    window.user_info = extractDataFromArray(response, ["data"], {});
    const token = extractDataFromArray(response, ["data", "authToken"], "");
    if (!isEmpty(token)) {
        localStorage.setItem("Authtk", token);
    }
    window.location.replace("/event-scanner/event-slots");
};

// export const isUserLoggedIn = () => {
//     return (typeof user_info != "undefined" && !empty(extractDataFromArray(user_info, ['email'], false))) || amILoggedIn();
// }

// export const amILoggedIn = () => {
//     if ($(".user_profile_header").hasClass("loggedIn") || sharedUserLoggedIn()) {
//         return true;
//     }
//     return false;
// }

// export const sharedUserLoggedIn = () => {
//     return (typeof __shared_page_loggedin != "undefined" && __shared_page_loggedin == 1);
// }

// Validations

// Function to validate email input
export const validEmail = (strInp) => {
    const emailRegex = /^(mailto:)?[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
    return emailRegex.test(strInp)
};

// export const validPassword = (strInp) => {
//     let res = { isError: false, errorMsg: "" };

//     // Check length
//     if (String(strInp).length < 8 || String(strInp).length > 90) {
//         res.isError = true;
//         res.errorMsg = "Invalid length.";
//         return res;
//     }

//     // Check for at least one special character
//     if (!/(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])/.test(strInp)) {
//         res.isError = true;
//         res.errorMsg = "Requires one special character.";
//         return res;
//     }

//     // Check for at least one number
//     if (!/(?=.*\d)/.test(strInp)) {
//         res.isError = true;
//         res.errorMsg = "Requires one number.";
//         return res;
//     }

//     return res;
// };

